export const appStoreURL =
    'https://itunes.apple.com/us/app/gaia-gps/id1201979492?mt=8&uo=4&at=10lqtF&ct=';
export const googlePlayURL =
    'https://market.android.com/details?id=com.trailbehind.android.gaiagps.pro&hl=en';
export const twitterURL = 'https://twitter.com/gaiagps';
export const instagramURL = 'https://www.instagram.com/gaiagps/';
export const youtubeURL = 'https://www.youtube.com/gaiagps';
export const facebookURL = 'http://www.facebook.com/GaiaGPS';
export const getGaiaFreeURL = '/register/';
export const getGaiaPremiumURL = '/checkout/premium/';
export const getOutsidePlusURL = '/checkout/outside/';
